<template>
  <div>
    <div class="options">
      <slot></slot>
    </div>
    <v-select
      :options="options"
      label="label"
      v-model="selectEntities"
      multiple
      :disabled="disabled"
      @input="onChangeValue"
      @search:focus="onFocus"
      @search:blur="onBlur"
    >
      <template v-slot:selected-option-container="{ option, deselect }">
        <span class="vs__selected">
          {{ option.label }}
          <button
            type="button"
            class="vs__deselect"
            @mousedown.prevent.stop="deselect(option)"
            :title="`Remover ${option.label}`"
            :aria-label="`Remover ${option.label}`"
          >
          <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10">
            <path
              d="M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z"
            />
          </svg>
        </button>
      </span>
      </template>
    </v-select>

    <div v-for="(item, index) in selectEntities" :key="item.value">
      <input type="hidden" :name="`${name}[${index}]`" :value="item.value"/>
      <input
        type="hidden"
        :name="`${name}-label[${index}]`"
        :value="item.label.trim()"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      required: true
    },
    value: {
      required: false,
      default: () => []
    },
    disabled: {
      required: false
    }
  },
  data: () => ({
    selectEntities: [],
    options: []
  }),
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        this.selectEntities = this.options.filter(item =>
          (Array.isArray(newVal) ? newVal : []).includes(item.value)
        );
      }
    }
  },
  methods: {
    generateOptions() {
      this.options = [];
      this.$el.querySelectorAll(".options option").forEach(option => {
        const item = {
          label: option.innerHTML.toUpperCase(),
          value: option.value
        };
        this.options.push(item);
      });

      this.options.sort((a, b) => {
        if (a.value.trim() === "") return -1;
        if (b.value.trim() === "") return 1;
        return a.label.trim().localeCompare(b.label.trim());
      });

      this.selectEntities = this.options.filter(item =>
        (Array.isArray(this.value) ? this.value : []).includes(item.value)
      );
    },
    onChangeValue() {
      const values = this.selectEntities.map(item => item.value);
      this.$emit("input", values);
      this.$emit("change", values);
    },
    onFocus() {
      setTimeout(() => {
        document.querySelectorAll("#content, .content").forEach(el => {
          if (el.scrollHeight > el.clientHeight) {
            el.style.height = el.scrollHeight + 20 + "px";
          }
        });
      }, 100);
    },
    onBlur() {
      document.querySelectorAll("#content, .content").forEach(el => {
        el.removeAttribute("style");
      });
    }
  },
  mounted() {
    this.generateOptions();
  }
};
</script>

<style lang="scss" scoped>
.options {
  display: none;
}

::v-deep {
  ul {
    li,
    li:hover {
      display: list-item;
      width: auto;
      border: none;
      border-radius: 0;
      padding: 5px 10px;
      box-shadow: none;
    }

    li:hover {
      background-color: #6f7efb;
    }
  }

  button {
    background: transparent !important;
    border: none !important;

    &:active {
      background: transparent !important;
      border: none !important;
    }
  }

  input {
    text-transform: unset;
  }

  .vs__dropdown-option {
    white-space: normal;
  }

  .vs--searchable .vs__dropdown-toggle {
    background: #fff;
  }

  .vs__clear {
    display: none;
  }
}
</style>
